<mps-loader></mps-loader>
<div class="skiplinks">
  <nav role="navigation" aria-label="Accès rapide" attr.aria-label="{{ 'skiplinks.quick_access' | translate }}">
    <ul class="skiplinks__list">
      <li>
        <a id="skiplink__content" href="home#content" class="link">
          {{ 'skiplinks.content' | translate }}
        </a>
      </li>
      <li>
        <a id="skiplink__menu" href="home#main-nav" class="link">
          {{ 'skiplinks.menu' | translate }}
        </a>
      </li>
      <li>
        <a id="skiplink__pied-de-page" href="home#footer" class="link">
          {{ 'skiplinks.footer' | translate }}
        </a>
      </li>
    </ul>
  </nav>
</div>
<div class="app-layout">
  <mps-app-header></mps-app-header>
  <app-search-dropdown></app-search-dropdown>
  <main id="content" role="main">
    <router-outlet></router-outlet>
  </main>
  <mps-app-footer id="footer"></mps-app-footer>
</div>
